import { render, staticRenderFns } from "./AgingReportsvue.vue?vue&type=template&id=6e97acb0&scoped=true"
import script from "./AgingReportsvue.vue?vue&type=script&lang=js"
export * from "./AgingReportsvue.vue?vue&type=script&lang=js"
import style0 from "./AgingReportsvue.vue?vue&type=style&index=0&id=6e97acb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97acb0",
  null
  
)

export default component.exports